export function pct(value, digits = 1) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "—";
  return `${(Number(value) * 100).toFixed(digits)}%`;
}

export function fmtDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtDateTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function fmtNum(value, digits = 0) {
  if (value === null || value === undefined || value === "") return "—";
  return Number(value).toLocaleString("en-IN", { maximumFractionDigits: digits });
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function addDaysISO(dateStr, days) {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

/** Plain words for the progress-entry metrics the API returns as codes. */
export const METRIC_LABELS = {
  QUANTITY_DELTA: "Today's output", QUANTITY_CUMULATIVE: "Corrected total", SCHEDULE_DATE: "Date", STAGE_DATE: "Date", DOC_STATUS: "Status",
};

export function metricLabel(value) {
  return METRIC_LABELS[value] || humanize(value);
}

/** A vendor or client in a dropdown: the name plus its code and GSTIN, so two parties with one name can be told apart. */
export function partyLabel(p) {
  if (!p) return "";
  const tail = [p.code, p.gstin].filter(Boolean).join(" · ");
  return tail ? `${p.name} (${tail})` : p.name;
}

export function humanize(value) {
  if (!value) return "—";
  return String(value).replaceAll("_", " ");
}

/** Amounts in a table cell: 1,23,456.00 — leaves non-numeric text (e.g. "N/A") exactly as it was. */
export function fmtMoney(value, digits = 2) {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return n.toLocaleString("en-IN", { minimumFractionDigits: digits, maximumFractionDigits: digits });
}
